import {
  DoGood,
  InternalHero,
  PetLandingPageType,
  Pricing,
  Questions,
  Reviews,
  TakeBetterCare,
  ValuePoints,
  WhatIsCovered,
} from '@/components/pet';
import { PageWrapper } from '@/components/shared/Content';
import Layout from '@/components/shared/Layout';
import { SEO } from '@/components/shared/SEO';
import { useGeoLookupContext } from '@/hooks/useGeoLookupContext';
import { config, type Config } from '@/pageConfig/pet/dogs/us/en';
import { PET_LANDING_PAGE } from '@/utils/productAdaPages';
import { PRODUCT_PET } from '@/utils/products';
import { useEffect } from 'react';

const extraAnalyticsParams = {
  pet_lp_type: PetLandingPageType.Dog,
  variant: PetLandingPageType.Dog,
};

export default function DogsPage({
  dynamicHeroTitle,
  dynamicConfig,
  dynamicAnalyticsParams,
}: {
  dynamicHeroTitle?: string;
  dynamicConfig: Config;
  dynamicAnalyticsParams?: Record<string, string>;
}) {
  const { trackEventWithGeolocation } = useGeoLookupContext();

  // biome-ignore lint/correctness/useExhaustiveDependencies: want to track event only once
  useEffect(
    () =>
      trackEventWithGeolocation('pet_landing_page.viewed', {
        ...extraAnalyticsParams,
        ...dynamicAnalyticsParams,
      }),
    [],
  );

  const finalConfig = dynamicConfig != null ? dynamicConfig : config;
  return (
    <Layout
      headerActions={finalConfig.layout.headerActions}
      product={PRODUCT_PET}
      page={PET_LANDING_PAGE}
      productType={PRODUCT_PET}
      menuCheckPricesExtraAnalyticsParams={{
        ...extraAnalyticsParams,
      }}
    >
      <SEO {...finalConfig.seo} />
      <PageWrapper>
        <InternalHero petLandingPageType={PetLandingPageType.Dog} dynamicHeroTitle={dynamicHeroTitle} />
        <ValuePoints petLandingPageType={PetLandingPageType.Dog} />
        <WhatIsCovered petLandingPageType={PetLandingPageType.Dog} />
        <TakeBetterCare petLandingPageType={PetLandingPageType.Dog} />
        <Pricing petLandingPageType={PetLandingPageType.Dog} />
        <Reviews petLandingPageType={PetLandingPageType.Dog} />
        <Questions petLandingPageType={PetLandingPageType.Dog} />
        <DoGood petLandingPageType={PetLandingPageType.Dog} />
      </PageWrapper>
    </Layout>
  );
}
